import React, { useState } from "react";
import styled from "styled-components";
import theme from "../../../assets/theme";

const Search = ({ placeholderText }) => {
  const [search, setSearch] = useState("");
  return (
    <StyleToolbar>
      <div className="input-icons">
        <div className="search-icons">
          <SearchIcon
            src={require("../../../assets/images/searchBar.svg")}
            alt="search_icon"
          />
        </div>
        <StyledInput
          value={search}
          placeholder={placeholderText}
          onChange={(e) => setSearch(e.target.value)}
          backgroundColor={"#ffffff"}
          width={"230px"}
        />
      </div>
    </StyleToolbar>
  );
};

export default Search;

const StyleToolbar = styled.div`
  display: flex;
  // align-items: center;
  justify-content: flex-end;
  margin-bottom: 12px;
  margin-top: 12px;
`;

const StyledInput = styled.input`
  width: 100%;
  height: 39px;
  border-radius: 10px;
  border: solid 1px #e1e3ee;
  background-color: ${({ backgroundColor }) => backgroundColor};
  outline: none;
  font-size: 14px;
  font-weight: 600;
  color: #acb1c2;
  font-family: ${theme.fonts.primaryFontRegular};
  padding-left: 35px;
  &::placeholder {
    color: #acb1c2;
  }
  @media ${theme?.breakpoints?.sm_up} {
    width: 220px;
  }
`;

const SearchIcon = styled.img`
  width: 16px;
  height: 16px;
`;
